<template>
  <div>
    <section id="singlePost" class="hero is-small">
      <div class="hero-body">
        <div class="container">
          <div class="articleHeader">
            <h1 class="singleBlogHead">
              {{ post.title }}
            </h1>
          </div>
          <img v-if="post.image.path" :src="'https://pitadmin.beneship.com/api/cockpit/image?token=68ba1b5eef8183911adad1903c81b9&src=https://pitadmin.beneship.com/storage/uploads' + post.image.path +'&w=680&o=1'" :alt="post.image.title" class="articleImage">
          <div v-if="!post.image.path" class="imagePlaceholder"><div /></div>
          <div class="postTags">
            <span class="posted">POSTED {{ post.datePublished | toDate }}</span>
            <nuxt-link v-for="(tag, key) in post.tags" :key="key" :to="'/category/'+tag">#{{ tag }}&nbsp;&nbsp;</nuxt-link>
          </div>
          <br>
          <article class="postContent">
            <div class="markdown" v-html="$options.filters.parseMd(post.content)" />
          </article>
          <template v-for="recipe in recipes">
            <component :is="componentForRecipe(recipe.recipeName)" :key="recipe.recipeName" :recipe-name="recipe.recipeName" :pre-pack="recipe.prePack" :post-pack="recipe.postPack" />
          </template>
        </div>
        <div :key="recipe" class="has-text-centered"><a href="/blog/">&larr; Back to blog</a><br><br></div>
      </div>
    </section>
    <BlogCta />
  </div>
</template>

<script>
import BlogCta from '~/components/blog/BlogCta.vue'
import { recipeManifest } from '~/components/recipes/mixins/manifest'

export default {
  components: {
    BlogCta
  },
  mixins: [recipeManifest],
  async asyncData ({ app, params, error, payload }) {
    if (payload) {
      return { post: payload }
    } else {
      const { data } = await app.$axios.post(process.env.POSTS_URL,
        JSON.stringify({
          ...process.env.defaultPostOptions,
          ...{
            filter: {
              title_slug: params.title_slug
            }
          }
        }),
        {
          headers: { 'Content-Type': 'application/json' }
        })

      if (!data.entries[0]) {
        return error({ message: '404 Page not found', statusCode: 404 })
      }

      return { post: data.entries[0] }
    }
  },
  computed: {
    recipes () {
      if (this.post.recipeCollection) {
        return this.post.recipeCollection.map((recipe) => {
          return {
            recipeName: recipe.recipe,
            prePack: recipe.pre,
            postPack: recipe.post
          }
        })
      } else if (this.post.recipes) {
        return this.post.recipes.split(',').map((recipe) => {
          return {
            recipeName: recipe
          }
        })
      }
      return []
    }
  },
  head () {
    return {
      title: this.post.title,
      meta: [
        { hid: 'description', name: 'description', content: this.post.excerpt },
        { hid: 'og:title', name: 'title', property: 'og:title', content: this.post.title },
        { hid: 'twitter:title', name: 'twitter:title', property: 'twitter:title', content: this.post.title },
        { hid: 'og:description', name: 'description', property: 'og:description', content: this.post.excerpt.replace(/<\/?[^>]+(>|$)/g, '') },
        { hid: 'twitter:description', property: 'twitter:description', content: this.post.excerpt.replace(/<\/?[^>]+(>|$)/g, '') },
        { hid: 'og:image', name: 'image', property: 'og:image', content: 'https://pitadmin.beneship.com/api/cockpit/image?token=68ba1b5eef8183911adad1903c81b9&src=https://pitadmin.beneship.com/storage/uploads' + this.post.image.path + '&w=1200&o=1' },
        { hid: 'twitter:image', property: 'twitter:image', content: 'https://pitadmin.beneship.com/api/cockpit/image?token=68ba1b5eef8183911adad1903c81b9&src=https://pitadmin.beneship.com/storage/uploads' + this.post.image.path + '&w=1200&o=1' }
      ]
    }
  }
}
</script>

<style scoped>
  span.posted{
    display: inline-block;
    margin-right: 1em;
  }
</style>
